import { rupiah } from "@/lib/api";

export const OrderBreakdown = ({ o, testid = "order-breakdown" }) => (
  <div className="space-y-1 text-sm" data-testid={testid}>
    <div className="flex justify-between text-muted2"><span>Subtotal</span><span>{rupiah(o.subtotal)}</span></div>
    {o.coins_used > 0 && <div className="flex justify-between text-forest" data-testid={`${testid}-discount`}><span>Potongan {o.coins_used} Coin</span><span>-{rupiah(o.discount)}</span></div>}
    <div className="flex justify-between text-muted2" data-testid={`${testid}-tax`}><span>{o.tax_name} {o.tax_rate}% (DPP {rupiah(o.dpp)})</span><span>{rupiah(o.tax_amount)}</span></div>
    {o.unique_code > 0 && <div className="flex justify-between text-muted2"><span>Kode unik</span><span>+{o.unique_code}</span></div>}
  </div>
);
